module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN306_93986815.7684256e.png";